/**
 * Requires getAttributeNames polyfill for IE11
 */
import { pipe } from 'ramda';

const getConfigElement = (id: string) => {
  const el = window.document.getElementById(id);

  if (!el) {
    throw new Error('appConfig element missing');
  }
  if (!el.hasAttributes()) {
    throw new Error('appConfig element has no config');
  }

  return el;
};

const parseConfig = (el: HTMLElement) => {
  const config: {
    [key: string]: string;
  } = {};

  for (const name of el.getAttributeNames()) {
    const value = el.getAttribute(name);
    const [, key] = name.split('data-');
    if (key) {
      config[key] = value || '';
    }
  }

  return config;
};

const getConfigFrom = pipe(getConfigElement, parseConfig);

export const getConfigWith = <
  TConfig extends { [key: string]: string | number | boolean }
>(
  mapConfig: (parsedConfig: { [key: string]: string }) => TConfig
) => (elementId: string) => pipe(getConfigFrom, mapConfig)(elementId);
